<p-dialog header="Edit Profile" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }">
    <form [formGroup]="editUserProfileFrom">
        <div class="grid mt-3 mb-3">
            <div class="col-4">
                <p class="mt-2"><label class="w-100 fs-6" for="usr_first_name_str">First Name</label></p>
                <p class="mt-5 pt-2"><label class="w-100 fs-6" for="usr_last_name_str">Last Name</label></p>
                <p class="mt-5 pt-1"><label class="w-100 fs-6" for="usr_email_str">Email</label></p>
                <p class="mt-5 pt-1"><label class="w-100 fs-6" for="usr_mobile_number_num">Mobile Number</label></p>
                <p class="mt-5 pt-1"><label class="w-100 fs-6" for="usr_pin_str">PIN</label></p>

            </div>
            <div class="col-8">
                <p class="font-bold">
                    <input class="w-100" type="text"
                           formControlName="usr_first_name_str"
                           pInputText
                           [style]="{ width: '83%' }"
                           id="usr_first_name_str"
                           name="userName"/>
                </p>
                <p class="font-bold">
                    <input class="w-100" type="text"
                           formControlName="usr_last_name_str"
                           pInputText
                           [style]="{ width: '83%' }"
                           id="usr_last_name_str"
                           name="userName"/>
                </p>
                <p class="font-bold">
                    <input class="w-100" type="text"
                           formControlName="usr_email_str"
                           pInputText
                           [style]="{ width: '83%' }"
                           id="usr_email_str"
                           readonly="readonly"
                           name="userEmail"/>
                </p>
                <p class="font-bold">
                    <input class="w-100" type="tel"
                           formControlName="usr_mobile_number_num"
                           pInputText
                           [style]="{ width: '83%' }"
                           maxlength="10"
                           (keydown)="this.utilsService.validateMobileNumber($event)"
                           id="usr_mobile_number_num"
                           name="userMobile"/>
                </p>
                <p class="font-bold">
                    <input id="pinCount1" formControlName="pin1" class="pin mr-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                    <input id="pinCount2" formControlName="pin2" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                    <input id="pinCount3" formControlName="pin3" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                    <input id="pinCount4" formControlName="pin4" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                    <input id="pinCount5" formControlName="pin5" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                    <input id="pinCount6" formControlName="pin6" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                </p>
            </div>
        </div>
        <div class="text-right">
            <p-button label="Cancel" class="mr-3" icon="pi pi-times" severity="secondary" (click)="visible = false"/>
            <p-button (click)="updateProfile()" [disabled]="editUserProfileFrom.invalid" icon="pi pi-save" label="Update"/>
        </div>
    </form>
</p-dialog>
<p-toast></p-toast>
